"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDefined = exports.isA = exports.areEmpty = void 0;
var _lodash = require("lodash");
var isDefined = obj => {
  if (!obj && obj !== 0) {
    return false;
  }
  return true;
};
exports.isDefined = isDefined;
var areEmpty = values => values.every(value => (0, _lodash.isEmpty)(value));
exports.areEmpty = areEmpty;
var isA = (value, name) => value && typeof value["is".concat(name)] === 'function' && value["is".concat(name)]();
exports.isA = isA;